import styled from 'styled-components';

export const Meta = styled.p`
  color: var(--color-text-muted);
  font-size: 11px;
  margin: 12px 0 0;
`;
